import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import client from "../../services/Client";
import Loading from "../../components/loader/Loading";
import arrowLeft from "../../asessts/Images/arrow_left.svg";
import { formatRole } from "../../utils/common";
import ImagePreviewModal from "../../components/common/ImagePreviewModal";
const FacilityPharmacyDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [pharmacyData, setPharmacyData] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);

  const fetchPharmacyDetail = async () => {
    setIsLoading(true);
    try {
      const response = await client.get(
        `/admin/healthFacility/get-pharmacy/${id}`
      );
      setPharmacyData(response?.data?.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching pharmacy details:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchPharmacyDetail();
    }
  }, [id]);

  return (
    <>
      <div className="admin-dashboard">
        <Sidebar />
        <div className="main-dashboard subadmin-dashboard">
          <Header
            title={
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <img
                  src={arrowLeft}
                  alt="Back"
                  style={{ cursor: "pointer", width: "22px", height: "22px" }}
                  onClick={() => navigate(-1)}
                />
                <span>Pharmacy Details</span>
              </div>
            }
          />
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <div className="setting-main request-main">
                <div className="setting-details">
                  <div className="basic-detail">
                    <div className="profile-upload">
                      <div className="profile-img">
                        <img src={pharmacyData?.information?.image} alt="" />
                      </div>
                    </div>
                    <div className="profile-details">
                      <div className="profile-head">
                        <div className="">
                          <h2>
                            {pharmacyData?.user?.firstName}
                            {pharmacyData?.user?.lastName}
                          </h2>
                          <p>
                            <span>Profile ID:</span> {pharmacyData?.profileId}
                          </p>
                        </div>
                      </div>
                      <div className="input-group">
                        <div class="input-field">
                          <label>Type</label>
                          <input
                            type="text"
                            placeholder="Henry"
                            value={
                              formatRole(pharmacyData?.facilityOrProfession) ||
                              "--"
                            }
                          />
                        </div>
                        <div class="input-field">
                          <label>Role</label>
                          <input
                            type="text"
                            placeholder="Estward"
                            value={formatRole(pharmacyData?.role) || "--"}
                          />
                        </div>
                        <div className="input-field">
                          <label>Phone Number</label>
                          <input
                            type="text"
                            placeholder="Phone"
                            value={
                              pharmacyData?.user?.phoneNumber
                                ? `+${pharmacyData.user.phoneNumber.dialCode} ${pharmacyData.user.phoneNumber.number}`
                                : "--"
                            }
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Email</label>
                          <input
                            type="text"
                            placeholder="Email"
                            value={
                              pharmacyData?.email ||
                              pharmacyData?.user?.email ||
                              "--"
                            }
                            readOnly
                          />
                        </div>
                        <div class="input-field">
                          <label>Address</label>
                          <textarea
                            className="input-address"
                            placeholder="Address"
                            value={pharmacyData?.information?.address?.add}
                          />
                        </div>
                        {/* <div className="input-field">
                        <label>Registration Number</label>
                        <input
                          type="text"
                          placeholder="Registration"
                          value={
                            pharmacyData?.information?.registrationNumber ||
                            "--"
                          }
                          readOnly
                        />
                      </div> */}
                      </div>
                      <div className="input-group">
                        {pharmacyData?.information?.additionalText && (
                          <div className="input-field" style={{ width: "48%" }}>
                            <label>Additional Text</label>
                            <textarea
                              placeholder="Description"
                              value={
                                pharmacyData?.information?.additionalText ||
                                "--"
                              }
                              readOnly
                            ></textarea>
                          </div>
                        )}
                        {pharmacyData?.specializations && (
                          <div className="input-field" style={{ width: "48%" }}>
                            <label>Specializations</label>
                            <textarea
                              placeholder="Specializations"
                              value={
                                pharmacyData?.specializations
                                  ? pharmacyData.specializations.join(", ")
                                  : "--"
                              }
                              readOnly
                            ></textarea>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {pharmacyData?.otherServices && (
                <div className="request-document">
                  <h3>Other Services</h3>
                  <div className="other-services-container">
                    {pharmacyData?.otherServices &&
                    pharmacyData.otherServices.length > 0 ? (
                      pharmacyData.otherServices.map((service, index) => (
                        <div className="service-card" key={index}>
                          <h5 className="service-name">
                            {service.name || "Service Name"}
                          </h5>
                          <p className="service-desc">
                            {service.information || "information"}
                          </p>
                        </div>
                      ))
                    ) : (
                      <p style={{ color: "#888" }}>No services available</p>
                    )}
                  </div>
                </div>
              )}
              {pharmacyData?.documents && (
                <div class="request-document">
                  <h3>Professional Documents</h3>
                  <div class="doc-main">
                    <div>
                      <div class="doc">
                        <div
                          class="doc-file"
                          onClick={() =>
                            setSelectedImage(
                              pharmacyData?.documents?.certificate
                            )
                          }
                        >
                          <img
                            style={{ width: "100%", height: "100%" }}
                            src={pharmacyData?.documents?.certificate}
                            alt=""
                          />
                        </div>
                        <div class="Document-name">
                          <span>
                            {pharmacyData?.documents &&
                            Object.keys(pharmacyData.documents).length > 0
                              ? Object.keys(pharmacyData.documents)[0]
                              : "No document available"}
                          </span>
                        </div>
                      </div>
                      {pharmacyData?.documents?.license !== "" ? (
                        <div class="doc">
                          <div
                            class="doc-file"
                            onClick={() =>
                              setSelectedImage(pharmacyData?.documents?.license)
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={pharmacyData?.documents?.license}
                              alt=""
                            />
                          </div>
                          <div class="Document-name">
                            <span>
                              {pharmacyData?.documents &&
                              Object.keys(pharmacyData.documents).length > 0
                                ? Object.keys(pharmacyData.documents)[1]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              )}

              {pharmacyData?.personalDocuments && (
                <div className="request-document">
                  <h3>Personal Documents</h3>
                  <div className="doc-main">
                    <div>
                      {pharmacyData?.personalDocuments?.nimc && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                pharmacyData?.personalDocuments?.nimc
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={pharmacyData?.personalDocuments?.nimc}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>NIMC</span>
                          </div>
                        </div>
                      )}
                      {pharmacyData?.personalDocuments?.license && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                pharmacyData?.personalDocuments?.license
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={pharmacyData?.personalDocuments?.license}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>License</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {selectedImage && (
        <ImagePreviewModal
          imageUrl={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </>
  );
};

export default FacilityPharmacyDetail;
